import { useEffect } from 'react';

// Norme Happn : jamais d'icône dans un bouton qui porte un texte. Le CSS ne voit pas les nœuds texte nus ;
// ce hook marque les boutons « texte + icône » (data-txt-icon) pour que da-happn.css cache l'icône.
const SEL = '.app-da button, .app-da a[class*="inline-flex"], .app-da a[class*="btn"], [role="dialog"] button, .ld a.ld-btn';
const SKIP = '[aria-haspopup], [role="tab"], [role="combobox"], [role="switch"], [aria-label]:not(.btn-kit), .hp-tile, .menu-moment, .sab-peek, .pil-arr, .hp-iconbtn, .hp-x, .more-btn, .hk-go, .hm-pin, .ckh-mini, [class*="rounded-full"]:not([class*="px-"]):not(.btn-kit), [class*="text-left"], [class*="flex-col"], .sab-fold-btn, .fin-more, .revenue-link, .stb-cta, .ck-nudge, .da-sidebar *, .app-header *, .mobile-tabbar *, [data-keep-icon], [data-keepicon], [data-keepicon] *';

const mark = (root) => {
  root.querySelectorAll(SEL).forEach((el) => {
    if (el.dataset.txtIcon !== undefined || el.matches(SKIP)) return;
    const svg = el.querySelector(':scope > svg, :scope > span > svg:only-child');
    if (!svg || svg.classList.contains('animate-spin') || svg.classList.contains('brand-logo') || svg.closest('.brand-logo')) return;
    const text = [...el.childNodes].filter((n) => !(n.nodeType === 1 && (n.matches('svg, .sr-only') || n.querySelector('.sr-only')))).map((n) => n.textContent).join('').trim();
    if (text.length >= 3) el.dataset.txtIcon = '1';
  });
};

export const useNoIconButtons = () => {
  useEffect(() => {
    let raf = 0;
    const run = () => { raf = 0; mark(document.body); };
    run();
    const obs = new MutationObserver(() => { if (!raf) raf = requestAnimationFrame(run); });
    obs.observe(document.body, { childList: true, subtree: true });
    return () => { obs.disconnect(); if (raf) cancelAnimationFrame(raf); };
  }, []);
};
